<template>
  <HeroNewsArticle :data="page" />

  <div class="my-16">
    <!-- the gallery spans the full width like on regular pages -->
    <ComponentsLoader
      v-editor-target="'content'"
      :components="page.content"
      container-indent="center"
      :full-width-types="['gallery']"
    />

    <Container indent="center">
      <SocialShareIcons :alternates="page.alternates" class="mt-12 xs:mt-24" />
    </Container>
  </div>

  <!-- SITE END REPLICATOR -->

  <ComponentsLoader
    v-if="page.news_article_site_end_replicator"
    v-editor-target="'news_article_site_end_replicator'"
    :components="page.news_article_site_end_replicator"
  />
</template>

<script setup>
provide('isNewsArticle', true)

defineProps({
  page: { type: Object, required: true },
})
</script>
